export class History {
  constructor() {
    this.currentLocation = window.location.href
  }

  maskHistory(url, title = '') {
    history.replaceState({currentLocation: this.currentLocation}, title, url);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/state/History.js